import './progressStepper.scss';

const ProgressStepper = ({steps, currentStep}: {steps: string[], currentStep: number}) => {
  return (
    <div className="progress-stepper-wrap">
      {steps.map((step, idx) => {
        return (
          <div  key={idx} className={`step ${currentStep === idx ? 'active' : ''}`}>
            <div className="circle">
              {currentStep === idx  ?  <i className='icon icon-10 icon-check-white' /> : idx+1}
              </div>
            <div className="label">{step}</div>
          </div>
        );
      })}
      <div className="line" />
    </div>
  );
};

export default ProgressStepper;